import { Typography } from "@/components/shared/typography";
import { View, Card, CardContent, Image } from "@/components/ui";
import MainCreditAccount from "@/assets/images/3d-icons/main-credit-account.png";
import { Star } from "@/components/shared/icons";
import { RadioDotItem } from "@/components/shared/radio-dot-item";
import { cn } from "@/lib/utils";

export const TopUpCreditCard = ({
  price,
  description,
  baseAmount,
  bonusAmount,
  isBestPick,
  expirationInMonth,
  isSelected,
  handleClick,
}: {
  price: number;
  description?: string;
  baseAmount: number;
  bonusAmount: number;
  isBestPick: boolean;
  expirationInMonth: number;
  isSelected?: boolean;
  handleClick(): void;
}) => {
  return (
    <Card
      onClick={handleClick}
      className={cn(
        "cursor-pointer border border-secondary-border",
        isSelected && "border-brand-primary-border",
      )}
    >
      <CardContent className="relative flex flex-col gap-3">
        {isBestPick && (
          <View className="absolute right-0 top-0 flex flex-row gap-2 rounded-bl-2xl rounded-tr-2xl bg-primary px-3 py-0.5">
            <Star weight="fill" className="color-white" size={16} />
            <Typography variant="caption-md" color="white">
              Best Pick
            </Typography>
          </View>
        )}
        <View className="flex flex-row items-center gap-4 border-b border-b-2 border-dashed border-secondary-border pb-3">
          <Image
            src={MainCreditAccount}
            className="size-16"
            width={64}
            height={64}
          />
          <View className="flex flex-1 flex-col gap-2">
            <Typography variant="label-sm" color="brand-primary">
              Buy ${price} → Get ${baseAmount + bonusAmount}
            </Typography>
            <Typography variant="body-sm" color="foreground-intermediate">
              {description || "Credit package"}
            </Typography>
          </View>
          <RadioDotItem
            size={26}
            checked={!!isSelected}
            onClick={handleClick}
          />
        </View>

        <View className="flex flex-row items-center justify-between">
          <Typography variant="caption-md" color="foreground-intermediate">
            Expired in {expirationInMonth} months
          </Typography>
        </View>
      </CardContent>
    </Card>
  );
};
